package team.platforma.multiplatform_material_extension.calendar.calendar_regular.api

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import team.platforma.multiplatform_material_extension.calendar.calendar_regular.core_ui.CalendarRegularImpl
import team.platforma.multiplatform_material_extension.calendar.properties.CalendarViewProperties
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarBadges
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarRange
import team.platforma.multiplatform_material_extension.calendar.utils.getAllDatesInMonth
import team.platforma.multiplatform_material_extension.calendar.utils.setStandardCalendarRange
import team.platforma.multiplatform_material_extension.util.gestures.HorizontalGestures

@Composable
fun CalendarRegular(
    modifier: Modifier? = null,
    initializeDate: LocalDate? = null,
    onDateSelected: (LocalDate) -> Unit,
    initializeMonth: Int? = null,
    initializeYear: Int? = null,
    calendarRange: CalendarRange? = null,
    onMonthSelected: (List<LocalDate>) -> Unit = {},
    horizontalGestures: HorizontalGestures? = null,
    properties: CalendarViewProperties? = null,
    calendarBadges: CalendarBadges? = null
) {

    val currentDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val initializeCalendarRange = calendarRange ?: setStandardCalendarRange(currentDate)

    val initDate: LocalDate = initializeDate?.let { customStartDate ->
        if (customStartDate in initializeCalendarRange.max..initializeCalendarRange.min) {
            customStartDate
        } else {
            initializeCalendarRange.min
        }
    } ?: if (currentDate in initializeCalendarRange.max..initializeCalendarRange.min) {
        currentDate
    } else {
        initializeCalendarRange.min
    }


    var selectedDate by remember { mutableStateOf(initDate) }

    LaunchedEffect(Unit) {
        val allDatesInMonth: List<LocalDate> =
            getAllDatesInMonth(
                initializeYear ?: selectedDate.year,
                initializeMonth ?: selectedDate.monthNumber
            )

        onDateSelected(selectedDate)
        onMonthSelected(allDatesInMonth)

    }

    CalendarRegularImpl(
        modifier = modifier ?: Modifier,
        currentDate = selectedDate,
        currentMonth = initializeMonth,
        currentYear = initializeYear,
        onDateSelected = { localDate ->
            selectedDate = localDate
            onDateSelected(selectedDate)
        },
        calendarRange = initializeCalendarRange,
        calendarBadges = calendarBadges,
        onMonthChange = { localDate ->
            val allDatesInMonth: List<LocalDate> =
                getAllDatesInMonth(localDate.year, localDate.monthNumber)
            onMonthSelected(allDatesInMonth)
        },
        horizontalGestures = horizontalGestures,
        properties = properties ?: CalendarViewProperties(),
        customStyle = null
    )
}